import { render, staticRenderFns } from "./ShowApproveWarning.vue?vue&type=template&id=73999f97"
import script from "./ShowApproveWarning.vue?vue&type=script&lang=js"
export * from "./ShowApproveWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports